import { handleActions } from 'redux-actions';
import {
  addCustomField,
  loadAllCustomFields,
  removeCustomField,
  addCustomFieldsToParent,
  updateCustomFields,
  updateCustomFieldParent,
  updateCustomFieldList,
} from 'redux/actions/customFieldActions';

const defaultState = {
  customFields: [],
};

export default handleActions(
  {
    [loadAllCustomFields](state, action) {
      return { ...state, customFields: action.payload };
    },
    [addCustomField](state, action) {
      const customFields = [...state.customFields, action.payload];
      return { ...state, customFields };
    },
    [addCustomFieldsToParent](state, action) {
      const { parentId, fieldIds } = action.payload;
      const updatedCustomFields = state.customFields.map((customField) => {
        if (fieldIds.some((fieldId) => fieldId === customField.id)) {
          return { ...customField, parentId };
        }
        return customField;
      });
      return { ...state, customFields: updatedCustomFields };
    },
    [updateCustomFields](state, action) {
      const updatedCustomField = action.payload;
      const updatedCustomFields = state.customFields.map((customField) => {
        return customField.id === updatedCustomField.id ? { ...updatedCustomField } : customField;
      });
      return { ...state, customFields: updatedCustomFields };
    },
    [updateCustomFieldParent](state, action) {
      const { updatedCustomField, childFieldIds } = action.payload;
      const updatedCustomFields = state.customFields.map((customField) => {
        if (customField.id === updatedCustomField.id) {
          return { ...updatedCustomField };
        }
        if (childFieldIds.some((fieldId) => fieldId === customField.id)) {
          return { ...customField, parentId: updatedCustomField.id, updated: true };
        }
        if (
          customField.parentId === updatedCustomField.id &&
          !childFieldIds.some((fieldId) => fieldId === customField.id)
        ) {
          return { ...customField, parentId: undefined, updated: true };
        }
        return customField;
      });
      return { ...state, customFields: updatedCustomFields };
    },
    [updateCustomFieldList](state, action) {
      const customFieldsToUpdate = action.payload;
      const updatedCustomFields = state.customFields.map((customField) => {
        const customFieldUpdated = customFieldsToUpdate.find(
          (currentCustomField) => currentCustomField.id === customField.id
        );
        if (customFieldUpdated) {
          return { ...customFieldUpdated };
        }

        return customField;
      });

      return { ...state, customFields: updatedCustomFields };
    },
    [removeCustomField](state, action) {
      const customFields = state.customFields.filter(
        (customField) => customField.id !== action.payload
      );
      return { ...state, customFields };
    },
  },
  defaultState
);
